import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { AccordionModule } from '../accordion/accordion.module';
import { TitleModule } from '../title/title.module';
import { GeneralFareComponent } from './general-fare/general-fare.component';
import { FareByTypeComponent } from './fare-by-type/fare-by-type.component';
import { BoxFareComponent } from './box-fare/box-fare.component';
import { RefundTaxesComponent } from './refund-taxes/refund-taxes.component';
import { MatTooltipModule } from '@angular/material/tooltip'; 

@NgModule({
  declarations: [
    GeneralFareComponent,
    FareByTypeComponent,
    BoxFareComponent,
    RefundTaxesComponent,
  ],
  imports: [CommonModule, SharedModule, TitleModule, AccordionModule, MatTooltipModule],
  exports: [
    GeneralFareComponent,
    FareByTypeComponent,
    BoxFareComponent,
    RefundTaxesComponent,
  ],
})
export class FareModule {}
